import './Header.css';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/design/logo2.png';
import caret from '../../assets/design/caretdown.png';
import FadeIn from '../../utils/fadein';
import { useState, useEffect } from 'react';
import {
  getCurrentUser,
  isAuthed,
  logout,
  isSeller,
  isBuyer,
  isEventHost,
  refresh,
  isAdmin
} from '../../services/auth.service';
import { hRefreshToken, addSellerRole, getMessageUnreadCount, getUserActivity, getPublicCategories, getUserAvailablePoints } from '../../utils/api';
import { FaCaretDown, FaChartLine, FaLink, FaSlidersH, FaTicketAlt, FaTimes, FaUsers, FaUsersCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {
  FaComment,
  FaUser,
  FaChartPie,
  FaRegEnvelope,
  FaUserCog,
  FaRegComments,
  FaPowerOff,
  FaMobile,
  FaMobileAlt,
  FaRegBell,
  FaBars
} from 'react-icons/fa';
import ManageRoles from '../manageroles/ManageRoles';
import iconSoftware from '../../assets/design/header/icon_platform_software.png';
import iconEvents from '../../assets/design/header/icon_platform_events.png';
import iconVendor from '../../assets/design/header/icon_platform_vendor.png';
import iconCommunity from '../../assets/design/header/icon_platform_community.png';
import iconContent from '../../assets/design/header/icon_platform_content.png';
import iconCoin from '../../assets/rewards/lp-coin.png';
import { Rocket } from 'lucide-react';

function Header({ authenticated, availablePoints }) {
  const [authed, setAuthed] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [showMenu, setShowMenu] = useState(false);
  const [showAddSeller, setShowAddSeller] = useState(false);
  const [showActivity, setShowActivity] = useState(false);
  const [hamburgerClicked, setHamburgerClicked] = useState(false);
  const [userActivity, setUserActivity] = useState([]);
  const [unreadCount, setUnreadCount] = useState('0');
  const [showRoles, setShowRoles] = useState();
  const [categories, setCategories] = useState([]);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showPlatformDropdown, setShowDropdownPlatform] = useState(false);
  const [showDashboardDropdown, setShowDashboardDropdown] = useState(false);
  const [showCommunityDropdown, setShowCommunityDropdown] = useState(false);
  //const [availablePoints, setAvailablePoints] = useState(0);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  let navigate = useNavigate();

  useEffect(() => {
    let user = getCurrentUser();

    if (user != null) {
      setAuthed(true);
      setCurrentUser(user);
    } else setAuthed(false);
  }, [authenticated]);

  async function handleLogout() {
    logout();
    setAuthed(false);
    setShowMenu(false);
    navigate('/', { replace: true });
  }

  async function loadCategories(){
    let res = await getPublicCategories();

    if (res.success){
      setCategories(res.data.slice(0, 10));
      setCategoriesLoaded(true);
    }
  }

  async function loadUnread(){
    let res = await getMessageUnreadCount();

    if (res.success){
      setUnreadCount(res.data);
    }
  }

  // force build
  function handleBurgerClick() {
    setHamburgerClicked(!hamburgerClicked);
    setShowModal(true);
    setShowMenu(!showMenu);
  }

  async function handleAddSeller() {
    setShowAddSeller(false);
    let res = await addSellerRole();

    if (res.success) {
      await hRefreshToken();
      window.location = '/dashboard/performance';
    }

    else if (res.status === 403){
      await refresh();

      let res = await addSellerRole();

      if (res.success) {
        await hRefreshToken();
        window.location = '/dashboard/seller';
      }
    }
  }

  async function toggleActivity(){
    setShowActivity(!showActivity);
    setShowModal(false);
  }

  async function handleLoadPoints(){
    // let res = await getUserAvailablePoints();

    // if (res.success){
    //   setAvailablePoints(res.data);
    // }
  }

  useEffect(() => {
    loadUnread();
    loadCategories();
    handleLoadPoints();
  }, []);

  useEffect(async () => {
    if (showActivity === true){
      let res = await getUserActivity();

      if (res.success){
        setUserActivity(res.data);
      }
    }
  }, [showActivity]);

  return (
    <>
      <div className='header'>
        <div className='header__left'>
          <div className='header__logo'>
            <a href='/'>
              <img src={logo} alt='leadrpro logo' />
            </a>
          </div>

          <div className='header__menu-items'>
            <div>
              <Link to={'/software'} className='header__menu-item-link'>Software Directory</Link>
            </div>

            <div>
              <a href='javascript:void(0)' onClick={() => {setShowCategories(!showCategories);
                setShowDropdownPlatform(false);
                setShowDashboardDropdown(false);
                setShowCommunityDropdown(false);
              }
              }>Categories <FaCaretDown /></a>

              {categoriesLoaded && showCategories && (
              <div className='header__dropdown'>
                {categories.map((c, index) => (
                  <div key={index} className='header__category'>
                    <a href={`/category/${c.slug}`}>{c.name}</a>
                  </div>
                ))}

                <div className='header__category' onClick={() => setShowCategories(false)}>
                  <a href='/software'>View all software</a>
                </div>
              </div>
              )}
            </div>

            <div>
              <a href='javascript:void(0)' onClick={() => {
                setShowDropdownPlatform(!showPlatformDropdown);
              setShowCategories(false);
            setShowDashboardDropdown(false);
          setShowCommunityDropdown(false);
        }
              }>Platform <FaCaretDown /></a>

              {showPlatformDropdown && (
              <div className='header__dropdown'>
                <div className='header__dropdown-label'>
                  Explore our LeadrPro platform
                </div>

                <div className='header__dropdown-menu-items'>
                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/software-hub');
                    setShowDropdownPlatform(false);
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconSoftware} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Software Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                        Discover new and innovative solutions
                      </div>
                    </div>
                  </div>

                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/events-hub');
                    setShowDropdownPlatform(false);
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconEvents} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Events Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                        Attend live or webinar events
                      </div>
                    </div>
                  </div>

                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/vendor-hub');
                    setShowDropdownPlatform(false)
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconVendor} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Vendor Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                      Sell your product on our platform for free
                      </div>
                    </div>
                  </div>

                  {/* <div className='header__dropdown-menu-item'>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconCommunity} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Community Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                      Network with industry leadrs and experts {'(Coming soon...)'}
                      </div>
                    </div>
                  </div> */}

                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/blog');
                    setShowDropdownPlatform(false);
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconContent} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Content Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                        Educational segments
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}
            </div>

            {authed && isSeller() && isBuyer() == false && (
              <div>
                <Link to='/dashboard/performance'>Dashboard</Link>
              </div>
            )}

            {authed && isBuyer() && isSeller() == false && (
              <div>
                <Link to='/dashboard/buyer'>Dashboard</Link>
              </div>
            )}

            {authed && isBuyer() && isSeller() == true && (
              <>
                <div>
                  <a href='javascript:void(0)' onClick={() => {setShowDashboardDropdown(!showDashboardDropdown);
                    setShowCategories(false);
                    setShowDropdownPlatform(false);
                    setShowCommunityDropdown(false);
                  }
                   } to='/dashboard/buyer'>Dashboards <FaCaretDown /></a>

{showDashboardDropdown && (
                <div className='header__dropdown'>
                  <div className='header__dropdown-label'>
                    Available dashboards
                  </div>

                  <div className='header__dropdown-menu-items'>
                    <div className='header__dropdown-menu-item' onClick={() => {
                      navigate('/dashboard/buyer');
                      setShowDashboardDropdown(false);
                    }}>
                      <div className='header__dropdown-menu-item-icon'>
                        <img src={iconSoftware} alt='' />
                      </div>

                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Discover Software</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Discover new and innovative solutions
                        </div>
                      </div>
                    </div>

                    <div className='header__dropdown-menu-item' onClick={() => {
                      navigate('/dashboard/performance');
                      setShowDashboardDropdown(false);
                    }}>
                      <div className='header__dropdown-menu-item-icon'>
                        <img src={iconVendor} alt='' />
                      </div>

                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Selling Software</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Manage your upcoming demos and team.
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                )}
                </div>
              </>
            )}

            <div>
              <a href='/launch/home'>
                <Rocket className='w-4 h-4' /> Weekly Launch
              </a>
            </div>

            {/* <div>
              <a href='javascript:void(0)' onClick={() => {
                setShowCommunityDropdown(!showCommunityDropdown);
                setShowCategories(false);
                setShowDropdownPlatform(false);
                setShowDashboardDropdown(false);
              }
                } to='/dashboard/buyer'>Community <FaCaretDown /></a>

{showCommunityDropdown && (
              <>
                <div className='header__dropdown'>
                  <div className='header__dropdown-label'>
                    Community events
                  </div>

                  <div className='header__dropdown-menu-items'>
                    <div className='header__dropdown-menu-item' onClick={() => {
                      navigate('/events');
                      setShowCommunityDropdown(false);
                    }}>
                      <div className='header__dropdown-menu-item-icon'>
                        <img src={iconEvents} alt='' />
                      </div>

                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Roundtable Events</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Register for exclusive in-person events
                        </div>
                      </div>
                    </div>

                    <div className='header__dropdown-menu-item' onClick={() => {
                      navigate('/webinars');
                      setShowCommunityDropdown(false);
                    }}>
                      <div className='header__dropdown-menu-item-icon'>
                        <img src={iconContent} alt='' />
                      </div>

                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Online Webinars</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Register for exclusive online webinars
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
              </>
            )}
            </div> */}

            {/* {authed === false && (
              <div>
                <Link onClick={() => {
                  setShowCommunityDropdown(false)
                }} to='/vendor-hub#pricing'>Pricing</Link>
              </div>
            )} */}

            {/* <div>
              <Link to='/events'>Events</Link>
            </div>

            <div>
              <Link to='/webinars'>Webinars</Link>
            </div> */}
          </div>
        </div>

        <div className='header__right'>
          {authed === false && (
            <div className='header__account-btns'>
              <Link to='/login' onClick={() => setShowMenu(false)} variant="ghost" className="text-gray-600 hover:text-purple-600">
                Sign In
              </Link>

              <Link className='header__account-btn header__account-btn--primary ml-4' to='/join-now'>
                Sign up
              </Link>
            </div>
          )}

          {authed && (
            <div className='header__logged-in'>
              {isBuyer() && (
                <Link to={'/dashboard/redeem'} className='header__point-count'>
                  <span>
                    <img src={iconCoin} alt='' style={{height: '24px'}} height={50} />
                  </span>

                  <span className='ml-10'>
                    {availablePoints}
                  </span>
                </Link>
              )}

              <div className='pointer' onClick={() => toggleActivity()}>
                <FaRegBell />
              </div>

              {showActivity && (
                <>
                  <div className={`header__modal-activity header__modal${showActivity ? ' show' : ''}`}>
                    <div className='header__activity-header'>Recent Activity</div>

                    {userActivity && userActivity.length == 0 && (
                      <div style={{padding: '20px', fontSize: '12px'}} className='center'><i>No recent activity found...</i></div>
                    )}
                    {userActivity.map((x, index) => (
                      <div key={index} className='header__activity-item'>
                        <div className='header__activity-item-date'>{new Date(x.date_created).toLocaleString()}</div>
                        <div className='header__activity-item-text'>{x.display_text}</div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <div className='header__profile' onClick={() => setShowMenu(!showMenu)}>
                <div className='header__profile-image'>
                  <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + currentUser.logo}
                  />
                </div>

                <div className='header__profile-info'>
                  <div className='header__profile-name'>
                    {currentUser.first_name}
                  </div>
                  <div className='header__company-name'>
                    {currentUser.company_name}
                  </div>
                </div>

                <div className='header__expand'>
                  <FaCaretDown />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={ hamburgerClicked ? 'header__hamburger active' : 'header__hamburger'} onClick={() => handleBurgerClick()}>
          <FaBars />
        </div>
      </div>

      {showMenu && (
            <div className={`header__modal`}>
              <div className='header__modal-section'>
              {authed === false && (
                <div className=''>
                  <div className='header__mobile-links'>
                    <div className='header__modal-link'>
                      <a href='/sellers'>Become A Seller</a>
                    </div>

                    <div className='header__modal-link'>
                      <a href='/pricing'>Pricing</a>
                    </div>
                    <div className='header__modal-link'>
                      <a href='/how-it-works'>How It Works</a>
                    </div>
                  </div>
                </div>
              )}

                {authed && isSeller() && (
                  <div className='header__modal-link'>
                    <Link to='/dashboard/performance' onClick={() => setShowMenu(false)}>
                      <span className='header__modal-link-icon'><FaChartLine /></span> <span>Seller Dashboard</span>
                    </Link>
                  </div>
                )}

                {authed && isBuyer() && isSeller() == false && (
                  <div className='header__modal-link'>
                    <Link to='/dashboard/buyer' onClick={() => setShowMenu(false)}>
                    <span className='header__modal-link-icon'><FaRegComments /></span> <span>Dashboard</span>
                    </Link>
                  </div>
                )}

                {authed && isBuyer() && isSeller() == true && (
                  <div className='header__modal-link'>
                    <Link to='/dashboard/buyer' onClick={() => setShowMenu(false)}>
                    <span className='header__modal-link-icon'><FaRegComments /></span> <span>Buyer Dashboard</span>
                    </Link>
                  </div>
                )}

                {authed && (isBuyer() || isSeller()) && (
                  <div className='header__modal-link'>
                    <Link to='/dashboard/inbox' style={{justifyContent: 'space-between'}} onClick={() => setShowMenu(false)}>
                    <span style={{marginLeft: '0px'}}>
                      <span className='header__modal-link-icon'>
                      <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.14636 0.478723C2.78139 0.803191 2.18748 2.08787 1.30399 4.4634L0 7.96936L0.0685524 10.8953C0.136037 13.7691 0.147783 13.8319 0.729516 14.4106L1.3215 15H9H16.6785L17.2705 14.4106C17.8522 13.8319 17.864 13.7691 17.9314 10.8953L18 7.96936L16.696 4.4634C15.8125 2.08787 15.2186 0.803191 14.8536 0.478723C14.3257 0.00936168 14.21 0 9 0C3.79002 0 3.67428 0.00936168 3.14636 0.478723ZM4.11442 2.17681C4.01554 2.44234 3.58479 3.59532 3.15725 4.73894C2.72949 5.88277 2.37968 6.86043 2.37968 6.9117C2.37968 6.96277 3.22004 7.03234 4.24725 7.06617L6.11482 7.12766L6.48065 7.90319C7.02651 9.05979 7.80215 9.57447 9 9.57447C10.1979 9.57447 10.9735 9.05979 11.5194 7.90319L11.8852 7.12766L13.7645 7.06596C15.9385 6.99468 15.8418 7.38362 14.5427 3.93617L13.7412 1.80851L9.01773 1.75128L4.29424 1.69404L4.11442 2.17681ZM1.95257 10.9574V13.1915H9H16.0474V10.9574V8.7234H14.5809H13.1144L12.5664 9.5483C11.9187 10.5234 10.144 11.4894 9 11.4894C7.85597 11.4894 6.0813 10.5234 5.43357 9.5483L4.88558 8.7234H3.41907H1.95257V10.9574Z" fill="#19202C"/>
</svg>
</span> <span>Inbox</span>
                    </span> 

                    {unreadCount != 0 && (
                      <span className='header__unread-badge'>New</span>
                    )}
                    </Link>
                  </div>
                )}

                {authed && isEventHost() && (
                  <div className='header__modal-link'>
                    <Link to='/account/events' onClick={() => setShowMenu(false)}>
                    <span className='header__modal-link-icon'><FaTicketAlt /></span> <span>Manage Events</span>
                    </Link>
                  </div>
                )}

                {authed && (
                  <div className='header__modal-link'>
                    <Link to='/account/home' onClick={() => setShowMenu(false)}>
                    <span className='header__modal-link-icon'>
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.23514 0C7.40336 0 6.67535 0.584702 6.50948 1.38317L6.33245 2.24174C5.44267 2.55687 4.63414 3.01369 3.92444 3.6013L3.08223 3.32466C2.29285 3.06471 1.41708 3.39171 1.00079 4.09721L0.999068 4.0989L0.23421 5.4011C-0.180875 6.10794 -0.0310962 7.01768 0.591717 7.55851L1.2586 8.13707C1.17453 8.58233 1.07985 9.02453 1.07985 9.5C1.07985 9.97547 1.17453 10.4177 1.2586 10.8629L0.591717 11.4415C-0.0308496 11.9821 -0.181618 12.8907 0.232491 13.5972V13.5989L0.999068 14.9011C1.41518 15.608 2.2941 15.9326 3.08223 15.6737L3.92615 15.397C4.63544 15.9844 5.44189 16.4433 6.33073 16.7583L6.50948 17.6151C6.67529 18.4151 7.40336 19 8.23514 19H9.76486C10.5966 19 11.3247 18.4153 11.4905 17.6168L11.6676 16.7583C12.5562 16.4434 13.3647 15.9859 14.0738 15.3987L14.916 15.6753C15.7042 15.9343 16.5848 15.608 17.0009 14.9011L17.7658 13.6006V13.5989C18.1802 12.8933 18.0302 11.9832 17.4083 11.4432L17.4066 11.4415L16.7414 10.8629C16.8255 10.4178 16.9201 9.97547 16.9201 9.5C16.9201 9.02453 16.8255 8.58233 16.7414 8.13707L17.4083 7.55851C18.0308 7.01789 18.1816 6.10927 17.7675 5.40279V5.4011L17.0009 4.0989C16.5848 3.39198 15.7059 3.06738 14.9178 3.32635L14.0738 3.60298C13.3646 3.01561 12.5581 2.55668 11.6693 2.24174L11.4905 1.38485V1.38317C11.3253 0.58297 10.5961 0 9.76486 0H8.23514ZM8.23514 1.72727H9.76486H9.76658L10.0347 3.02441C10.067 3.18021 10.1426 3.32422 10.2529 3.4406C10.3633 3.55697 10.5043 3.64118 10.6603 3.68395C11.6716 3.96157 12.5771 4.48203 13.3055 5.18182C13.4215 5.29295 13.5665 5.37051 13.7245 5.40593C13.8825 5.44134 14.0474 5.43325 14.201 5.38255L15.4764 4.96422L16.2412 6.26305V6.26474L15.2306 7.14187C15.1094 7.24706 15.0201 7.38301 14.9724 7.53478C14.9248 7.68654 14.9208 7.84825 14.9607 8.00213C15.0875 8.4898 15.1601 8.98826 15.1601 9.5C15.1601 10.0117 15.0875 10.5102 14.9607 10.9979C14.9208 11.1517 14.9248 11.3135 14.9724 11.4652C15.0201 11.617 15.1094 11.7529 15.2306 11.8581L16.2412 12.7353L15.4764 14.0375L14.1993 13.6175C14.0455 13.567 13.8805 13.5591 13.7225 13.5949C13.5645 13.6306 13.4196 13.7084 13.3038 13.8199C12.5754 14.5197 11.6699 15.0384 10.6586 15.3161C10.5029 15.3591 10.3623 15.4434 10.2522 15.5598C10.1422 15.6761 10.0669 15.82 10.0347 15.9756L9.76486 17.2727H8.23514L8.23342 17.271L7.96529 15.9756C7.93297 15.8198 7.85745 15.6758 7.74706 15.5594C7.63667 15.443 7.49569 15.3588 7.33966 15.3161C6.32836 15.0384 5.42289 14.518 4.69445 13.8182C4.57849 13.707 4.43352 13.6295 4.27551 13.5941C4.1175 13.5587 3.95259 13.5667 3.79896 13.6175L2.52363 14.0358L1.75877 12.7369V12.7353L2.76941 11.8581C2.89063 11.7529 2.97994 11.617 3.02755 11.4652C3.07516 11.3135 3.07921 11.1517 3.03926 10.9979C2.91249 10.5102 2.83988 10.0117 2.83988 9.5C2.83988 8.98826 2.91249 8.4898 3.03926 8.00213C3.07921 7.84825 3.07516 7.68654 3.02755 7.53478C2.97994 7.38301 2.89063 7.24706 2.76941 7.14187L1.75877 6.26474L2.52363 4.96422V4.96254L3.79896 5.38255C3.95274 5.43304 4.11774 5.44086 4.27576 5.40514C4.43378 5.36942 4.57867 5.29156 4.69445 5.18013C5.42422 4.47981 6.3276 3.96156 7.33966 3.68395C7.49569 3.64118 7.63667 3.55697 7.74706 3.4406C7.85745 3.32422 7.93297 3.18021 7.96529 3.02441L8.23514 1.72727ZM9 6.04545C7.89998 6.04545 6.96296 6.48138 6.36167 7.14524C5.76038 7.8091 5.47993 8.66035 5.47993 9.5C5.47993 10.3396 5.76038 11.1909 6.36167 11.8548C6.96296 12.5186 7.89998 12.9545 9 12.9545C10.1 12.9545 11.037 12.5186 11.6383 11.8548C12.2396 11.1909 12.5201 10.3396 12.5201 9.5C12.5201 8.66035 12.2396 7.8091 11.6383 7.14524C11.037 6.48138 10.1 6.04545 9 6.04545ZM9 7.77273C9.66001 7.77273 10.043 7.98453 10.3217 8.29226C10.6005 8.59999 10.76 9.04419 10.76 9.5C10.76 9.95581 10.6005 10.4 10.3217 10.7077C10.043 11.0155 9.66001 11.2273 9 11.2273C8.33999 11.2273 7.95698 11.0155 7.67826 10.7077C7.39953 10.4 7.23997 9.95581 7.23997 9.5C7.23997 9.04419 7.39953 8.59999 7.67826 8.29226C7.95698 7.98453 8.33999 7.77273 9 7.77273Z" fill="#19202C"/>
</svg>
</span> <span>Settings</span>
                    </Link>
                  </div>
                )}

                <div className='header__modal-link'>
                  <Link to='/app' onClick={() => setShowMenu(false)}>
                  <span className='header__modal-link-icon'><FaMobileAlt /></span> <span>Get the App</span>
                  </Link>
                </div>

                <div className='header__modal-link'>
                    <a href='javascript:void(0)' className='' onClick={() => {
                      setShowRoles(true);
                      setShowMenu(false);
                    }}>
                      <span><FaUsers /></span>
                      <span>Manage Roles</span>
                    </a>
                  </div>

                {authed && (
                  <div className='header__log-out'>
                    <div className='header__btn-logout' onClick={handleLogout}>
                      <span><svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.816 0.0232112C18.5739 0.0823972 18.3635 0.22879 18.2124 0.443193L18.0706 0.644453V8.00529V15.3661L18.2138 15.5696C18.4117 15.8507 18.6967 16 19.0353 16C19.3739 16 19.6589 15.8507 19.8568 15.5696L20 15.3661V8.00529V0.644453L19.8568 0.440939C19.6241 0.110512 19.1831 -0.0665299 18.816 0.0232112ZM9.70485 3.04545C9.46381 3.12022 9.2192 3.32486 9.10579 3.54663C8.98155 3.78943 8.98014 4.19355 9.10264 4.42832C9.15266 4.52407 9.72442 5.13034 10.3732 5.77547C11.0221 6.42065 11.5529 6.96426 11.5529 6.9835C11.5529 7.00274 9.0896 7.02401 6.07892 7.03081L0.604847 7.04311L0.431059 7.16045C0.335482 7.22499 0.199388 7.36049 0.128659 7.46154C0.0156706 7.62286 0 7.68913 0 8.00529C0 8.32145 0.0156706 8.38772 0.128659 8.54904C0.199388 8.65009 0.335482 8.7856 0.431059 8.85014L0.604847 8.96747L6.07892 8.97977C9.0896 8.98658 11.5529 9.00718 11.5529 9.02558C11.5529 9.04398 11.0036 9.60871 10.3322 10.2805C9.66089 10.9523 9.08913 11.5615 9.06165 11.6341C8.98 11.8503 9.00122 12.2595 9.10452 12.4615C9.31529 12.8736 9.78513 13.0866 10.2471 12.9795C10.4887 12.9235 10.5419 12.8748 12.6506 10.7806C13.9096 9.53019 14.8467 8.56261 14.9024 8.45559C14.9653 8.33445 14.9976 8.18168 14.9976 8.00529C14.9976 7.82891 14.9653 7.67613 14.9024 7.55499C14.8467 7.44788 13.9104 6.48143 12.6506 5.23069C10.6381 3.23263 10.4794 3.0861 10.2733 3.03644C10.0083 2.97251 9.93624 2.97369 9.70485 3.04545Z" fill="#EF4E6D"/>
</svg>
</span>
                      <span className='ml-10' style={{marginTop: '-5px'}}>Log out</span>
                    </div>
                  </div>
                )}

                {authed === false && (
                  <div className='header__menu-account-btns flex align-center gap-4'>
                    <Link onClick={() => setShowMenu(false)} className='header__account-btn' to='/login'>
                      Login
                    </Link>

                    <Link onClick={() => setShowMenu(false)} className='header__account-btn header__account-btn--primary ml-4' to='/signup'>
                      Sign up
                    </Link>
                  </div>
                )}
              </div>
            </div>
          )}

      {showAddSeller && (
        <>
          <div className='overlay'></div>

          <div className='modal modal--wide'>
            <div className='modal__close' onClick={() => setShowAddSeller(false)}>
              <FaTimes />
            </div>

            <p className='modal__h2'>
              Add your company to our solutions directory for FREE
            </p>

            <p className='mt-20'>
              <img src='https://ik.imagekit.io/ivgrhmd4k/Screenshot_2023-04-23_193143.png?updatedAt=1682303817301' />
            </p>

            <p className='mt-20'>
              <h3>Benefits:</h3>

              <ul style={{ listStyleType: 'disc' }}>
                <li>Free company public listing</li>

                <li>
                  Search 1000's of prospects matching your ideal candidate
                  profile
                </li>

                <li>
                  Get real interested candidates looking for solutions just like yours
                </li>
              </ul>
            </p>

            <p className='mt-30 center'>
              <button className='btn btn--primary' onClick={() => handleAddSeller()}>
                Get Started
              </button>
            </p>
          </div>
        </>
      )}

      {showRoles && (
          <div className='header__manage-roles'>
            <ManageRoles />

            <div className='center'>
              <button className='btn' onClick={() => setShowRoles(false)}>Back</button>
            </div>
          </div>
      )}
    </>
  );
}

export default Header;
